import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import * as serviceWorker from './serviceWorker'
// NOTE: iOS12Safari対応 Promise.allSettled()を使うため
import 'ts-polyfill'

const container = document.getElementById('root')
if (!container) throw new Error('Failed to find the root element')
// Create a root.
const root = createRoot(container)
// Initial render: Render an element to the root.
root.render(<App />)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
